import { useState } from "react";
import { SECTION_TEMPLATES } from "@/lib/sectionTemplates";
import { X, GripVertical, ArrowUp, ArrowDown, Trash2, Plus, Layers } from "lucide-react";

export default function SectionsPanel({ sections, onReorder, onDelete, onInsert, onClose }) {
  const [dragIdx, setDragIdx] = useState(null);

  const move = (from, to) => {
    if (to < 0 || to >= sections.length) return;
    const next = [...sections];
    const [item] = next.splice(from, 1);
    next.splice(to, 0, item);
    onReorder(next);
  };

  return (
    <div
      className="absolute top-0 left-0 h-full w-72 max-w-[85%] bg-[#141414] border-r border-white/10 z-20 flex flex-col"
      data-testid="sections-panel"
    >
      <div className="flex items-center justify-between px-4 h-12 border-b border-white/10 shrink-0">
        <span className="text-xs font-mono uppercase tracking-wider text-primary flex items-center gap-1.5">
          <Layers className="w-3.5 h-3.5" /> Sezioni
        </span>
        <button onClick={onClose} className="text-muted-foreground hover:text-white" data-testid="sections-close">
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-3 space-y-4">
        <div>
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground mb-2 px-1">Ordina (trascina)</p>
          <div className="space-y-1.5">
            {sections.length === 0 && (
              <p className="text-xs text-muted-foreground px-1">Nessuna sezione rilevata.</p>
            )}
            {sections.map((s, i) => (
              <div
                key={s.id}
                draggable
                onDragStart={() => setDragIdx(i)}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => { if (dragIdx !== null && dragIdx !== i) move(dragIdx, i); setDragIdx(null); }}
                onDragEnd={() => setDragIdx(null)}
                className={`group flex items-center gap-2 bg-white/5 border border-white/10 rounded-lg px-2 py-2 text-xs ${dragIdx === i ? "opacity-40" : ""}`}
                data-testid={`section-item-${i}`}
              >
                <GripVertical className="w-3.5 h-3.5 text-muted-foreground cursor-grab shrink-0" />
                <span className="flex-1 truncate text-white/80">{s.label}</span>
                <button onClick={() => move(i, i - 1)} className="text-muted-foreground hover:text-white" data-testid={`section-up-${i}`}>
                  <ArrowUp className="w-3.5 h-3.5" />
                </button>
                <button onClick={() => move(i, i + 1)} className="text-muted-foreground hover:text-white" data-testid={`section-down-${i}`}>
                  <ArrowDown className="w-3.5 h-3.5" />
                </button>
                <button onClick={() => onDelete(s.id)} className="text-muted-foreground hover:text-destructive" data-testid={`section-delete-${i}`}>
                  <Trash2 className="w-3.5 h-3.5" />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div>
          <p className="text-[11px] uppercase tracking-wider text-muted-foreground mb-2 px-1">Aggiungi sezione</p>
          <div className="grid grid-cols-2 gap-2">
            {SECTION_TEMPLATES.map((t) => (
              <button
                key={t.id}
                onClick={() => onInsert(t)}
                className="flex flex-col items-center gap-1.5 border border-white/10 rounded-lg py-3 hover:border-primary/40 hover:bg-white/[0.04] transition-all text-xs"
                data-testid={`add-section-${t.id}`}
              >
                <i className={`fa-solid ${t.icon} text-primary`} />
                {t.name}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
